<template>
    <div>
        <div class="smallContent">
            <div class="elementContainer">
                <ShopElement
                    v-for="(item, index) in products"
                    :key="item.id"
                    :item="item"
                ></ShopElement>
            </div>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
import { store } from "../store";
import ShopElement from "./ShopElement";
import axios from "axios";
import Footer from "./Footer.vue";

export default {
    name: "Shop",
    components: {
        ShopElement,
        Footer,
    },
    data() {
        return {
            store: store,
            products: [],
        };
    },
    mounted: function () {
        let myself = this;
        axios.get("/api/shop").then((response) => {
            this.products = response.data.products;
        });
        //axios
        //.get('/api/get-streams')
        //.then(response => {
        //this.streams = response.data.items;
        //})
    },
};
</script>

<style scoped>
.seperator {
    padding: 0.7rem 1rem 0.7rem;
    border-top: 1px solid black;
}
#archiveLink {
    font-size: 12px;
    font-family: "Montez Small";
    display: flex;
    align-items: center;
    gap: 1rem;
}
.seperator.playlist {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
@keyframes blink-animation {
    to {
        visibility: hidden;
    }
}
@-webkit-keyframes blink-animation {
    to {
        visibility: hidden;
    }
}
.blink {
    margin-left: 0.7rem;
    animation: blink-animation 2s steps(2, start) infinite;
    -webkit-animation: blink-animation 2s steps(2, start) infinite;
}
.blink.mobile {
    font-family: "Montez Small";
    font-size: 1rem;
}

#scheduleElement {
    background-color: #fcfac4;
    /*min-height: calc(100vw - 2rem);*/
    height: auto;
    min-width: calc(100vw - 4rem);
    padding: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /*box-shadow: inset 0px 0px 2rem 1rem white*/
}
#scheduleElement p {
    text-align: center;
    width: calc(100% - 4rem);
}
@media only screen and (min-width: 738px) {
    #scheduleElement {
        /*min-height: calc(50vw - 2rem);*/
        /*min-width: calc(50vw - 2rem);*/
        /*margin: 0.5rem 0;*/
    }
}
@media only screen and (min-width: 1101px) {
    #scheduleElement {
        /*min-height: calc(33.3vw - 2rem);*/
        /*min-width: calc(66.6vw - 2rem);*/
    }

    #scheduleElement p {
        width: 75%;
    }
}
@media only screen and (min-width: 1440px) {
    #scheduleElement {
        /*min-height: calc(25vw - 3rem);*/
        /*min-width: calc(75vw - 2rem);*/
    }
}
@media only screen and (min-width: 1900px) {
    #scheduleElement {
        /*min-height: calc(20vw - 2rem);*/
        /*min-width: calc(80vw - 2rem);*/
    }
}

#streams {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(350px, 100%), 1fr));
    gap: 1rem;
    margin: 1rem 1rem 2rem;
}
.stream {
    border: 1px solid black;
    display: flex;
    gap: 1rem;
    padding: 1rem;
    align-items: center;
}
.stream > p {
    margin: 0;
}
.stream > img {
    width: 51px;
    height: 51px;
    object-fit: cover;
}
.playlistItem {
    padding: 0.5rem 1rem;
    display: flex;
    gap: 1rem;
    align-items: center;
    white-space: nowrap;
    color: grey;
    font-size: 12px;
    font-family: "Montez Small";
    line-height: initial;
}
.playlistItem:last-child {
    padding-bottom: 2rem;
}
.playlistItem.desktop {
    font-size: initial;
    font-family: "Montez Large";
    padding: 1rem;
    border-top: 1px solid lightgrey;
}
.remain {
    flex-shrink: 0;
    font-size: 12px;
    font-family: "Montez Small";
    text-align: right;
}
.playlistItem > .title {
    flex-grow: 1;
}
.playlistItem > img {
    flex-shrink: 0;
    object-fit: cover;
    height: 51px;
    width: 51px;
}
.playlistItem.desktop > img {
    height: 26px;
    width: 26px;
}
.playlistItem.activeItem {
    color: black;
    border-top: none;
}
.playlistItem.activeItem > img {
    height: 51px;
    width: 51px;
}
#play,
#pause {
    cursor: pointer;
    height: 3rem;
    width: 3rem;
    object-fit: cover;
}
#archiveLink {
    height: 1.7rem;
}

#title {
    flex-grow: 1;
    overflow: hidden;
}
#title > * {
    overflow: hidden;
    text-overflow: ellipsis;
}
#title.mobile {
    display: flex;
    flex-direction: column;
}
#title.desktop {
    display: grid;
    gap: 1rem;
    grid-template-columns: auto 2fr 2fr 1fr 1fr 1fr;
}
#titleLocation {
    display: flex;
    gap: 1rem;
}
#title.activeItem {
    display: flex;
    flex-direction: column;
}
.playlistDate {
    font-variant-numeric: tabular-nums;
    font-feature-settings: "case" on;
}
#archiveText {
    white-space: nowrap;
}
</style>
